export const xContentPadding = 8;
export const yContentPadding = 8;
export const mainContentOffset = 66;
export const mainContentOffsetMobile = 68;
